@import "config";

.container {
	outline: 1px solid $color-light-l2;
	font-size: $font-size-xxs;
	line-height: $font-line-heights-far;
	font-weight: $font-weight-regular;
	color: $color-dark-d1;
	padding-inline: $spacing-inline-xxxs;
	padding-block: $spacing-inset-nano;
	border-radius: $border-radius-sm;
	background-color: transparent;
	border: 0;
	cursor: pointer;
	transition: all 0.2s;

	&:not(:disabled) {
		&.selected {
			outline-color: $color-primary-pure;
			color: $color-primary-pure;
			background-color: $color-primary-lightest;
			font-weight: $font-weight-bold;
		}

		&:hover,
		&:focus-within {
			outline-color: $color-primary-pure;
			color: $color-primary-pure;
			font-weight: $font-weight-bold;
		}
	}

	&:disabled {
		background-color: $color-light-l1;
		color: $color-dark-d4;
		outline-color: transparent;
		cursor: default;
	}
}
